import {
  DEFAULT_BLACK_IMAGE_PATH,
} from '../../../scripts/Routes/images.js';

export const books2019 = [
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'The Road Less Traveled - M Scott Peck',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Extreme Ownership - Jocko Willink',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'I.M. Wright Hard Code - Eric Brechner',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'TB12 Method',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Zen and the Art of Motorcycle Maintenance',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'The Big Short',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Learn the Fundamentals of Docker',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Principles by Ray Dalio',
        'url': '#',
    },
];
